import React from "react";
import { RegisterOptions } from "react-hook-form";
import { CountryField, FormItem } from "..";
import { CountryControlProps } from "./CountryControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function CountryControl(props: CountryControlProps) {
  const {
    defaultValue,
    getCountryFieldProps,
    hideHelperText,
    label,
    name,
    onChangeValue,
    required,
    valuePropName,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {};
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    return result;
  }, [label, required]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getCountryFieldProps?.(params);
    },
    [getCountryFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      onChangeValue={onChangeValue}
      rules={rules}
      valuePropName={valuePropName}
    >
      <CountryField {...other} label={label} />
    </FormItem>
  );
}

export default React.memo(CountryControl);
